/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Donate_Water_PlanInputs */

const en_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preserves ~${i?.number} L of water a year`)
};

const ar_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يحفظ ~${i?.number} لتر من الماء سنويًا`)
};

const de_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spart ~${i?.number} L Wasser pro Jahr`)
};

const es_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conserva ${i?.number} L de agua al año`)
};

const fr_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Économise près de ~${i?.number} L d'eau chaque année`)
};

const it_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conserva ~${i?.number} L di acqua all'anno`)
};

const ja_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`年間約${i?.number}Lの水を節約`)
};

const ko_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`매년 최대 ${i?.number}L의 수자원 절약`)
};

const pt_br_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preserva ~${i?.number} L de água por ano`)
};

const ru_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сохраняет ~${i?.number} л воды в год`)
};

const th_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อนุรักษ์น้ำ ~${i?.number} ล. ต่อปี`)
};

const tr_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yılda ~${i?.number} L su tasarrufu sağlar`)
};

const zh_cn_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年保存约 ${i?.number} 公升水资源`)
};

const zh_tw_earth_day_2025_donate_water_plan = /** @type {(inputs: Earth_Day_2025_Donate_Water_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年保存約 ${i?.number} 公升水資源`)
};

/**
* | output |
* | --- |
* | "Preserves ~{number} L of water a year" |
*
* @param {Earth_Day_2025_Donate_Water_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_water_plan = /** @type {((inputs: Earth_Day_2025_Donate_Water_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Water_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_water_plan(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_water_plan(inputs)
	if (locale === "de") return de_earth_day_2025_donate_water_plan(inputs)
	if (locale === "es") return es_earth_day_2025_donate_water_plan(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_water_plan(inputs)
	if (locale === "it") return it_earth_day_2025_donate_water_plan(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_water_plan(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_water_plan(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_water_plan(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_water_plan(inputs)
	if (locale === "th") return th_earth_day_2025_donate_water_plan(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_water_plan(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_water_plan(inputs)
	return zh_tw_earth_day_2025_donate_water_plan(inputs)
});